import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { getUserPayments } from "../../shared/requests-api";
import { getUserToken } from "../../shared/utils";
import { formatCurrency } from "../../../../js/shared/utils";
import { ROUTE_SALE } from "../../shared/constants";
import Loading from "../../../shared/Loading/Loading";
import { MonthsPTBR } from "../../shared/enums";
import { receiveSummaryPayment } from "../../actions";
import { summaryPayment } from "./../../reducers/summary-payment";

class SummaryPayment extends Component {
	constructor() {
		super();

		this.state = {
			showDetails: false
		};
	}

	componentDidMount() {
		const self = this;
		const { summaryPayment, receiveSummaryPayment } = this.props;

		if ((!summaryPayment || summaryPayment.thisMonth == 0) && receiveSummaryPayment) {
			self.setState({ loading: true });
			getUserPayments(getUserToken())
				.then(response => {
					if (self._unmounted) return;
					self.setState({
						loading: false
					});
					receiveSummaryPayment(response.data);
				})
				.catch(res => {
					if (self._unmounted) return;
					self.setState({
						loading: false
					});
				});
		}
	}

	componentWillUnmount() {
		this._unmounted = true;
	}

	searchPayments() {
		const token = getUserToken();
	}

	render() {
		const { expand, showDetails, loading } = this.state;
		const { summaryPayment } = this.props;

		if (!summaryPayment) {
			return null;
		}

		let currentMonth = "",
			nextMonth = "";
		if (summaryPayment.thisMonth) {
			currentMonth = MonthsPTBR[summaryPayment.thisMonth];
			nextMonth = MonthsPTBR[summaryPayment.thisMonth + 1];
			if (!nextMonth) {
				nextMonth = MonthsPTBR[1];
			}
		}
		let totalFee = summaryPayment.feeReceived + summaryPayment.feeToReceive;

		if (window.screen.availWidth < 992) {
			return (
				<div className="summary-payment">
					<h1 className="my-offers--header">Minhas Ofertas</h1>
					{loading && <Loading label="Carregando valores" />}
					{!loading && (
						<div className="summary-payment--current-month-mobile">
							<p className="month-name">
								<strong>{currentMonth.toUpperCase()}</strong>
							</p>
							<div className="row summary-payment--current-month-mobile">
								{!showDetails && (
									<div>
										<div className="col-xs-8 miles">
											<p className="identifier">Milhas</p>
											<div className="total-closed">
												<p className="identifier">Total:</p>
												<p className="value">
													<strong>{formatCurrency(summaryPayment.totalMonth)}</strong>
												</p>
											</div>
										</div>
										<div className="col-xs-8 miles fees">
											<p className="identifier">Taxas</p>
											<div className="total-closed">
												<p className="identifier">Total:</p>
												<p className="value">
													<strong>
														{formatCurrency(
															summaryPayment.feeToReceive + summaryPayment.feeRecived
														)}
													</strong>
												</p>
											</div>
										</div>
										<div
											className={`summary-payment__details-button ${showDetails ? "opened" : ""}`}
										>
											<button
												className="btn btn-icon"
												onClick={() => this.setState({ showDetails: !showDetails })}
												data-action="summary-payment-expand-collapse"
											>
												<i className="icon-arrow-down" />
											</button>
										</div>
									</div>
								)}

								{showDetails &&
									!loading && (
										<React.Fragment>
											<span />
											<div>
												<div className="col-xs-8 identifier-opened-div">
													<p className="identifier-opened">Milhas</p>
												</div>
												<div className="col-xs-8 identifier-opened-div">
													<p className="identifier-opened">Taxas</p>
												</div>
												<div className="col-xs-8 miles-opened">
													<div className="to-receive">
														<p className="identifier">A receber:</p>
														<p className="value">
															<strong>{formatCurrency(summaryPayment.toReceive)}</strong>
														</p>
													</div>
													<div className="plus-separator">
														<p>+</p>
													</div>
													<div className="received">
														<p className="identifier">Recebido:</p>
														<p className="value">
															<strong>{formatCurrency(summaryPayment.received)}</strong>
														</p>
													</div>
													<div className="equals-separator">
														<p>=</p>
													</div>
													<div className="total">
														<p className="identifier">Total:</p>
														<p className="value">
															<strong>{formatCurrency(summaryPayment.totalMonth)}</strong>
														</p>
													</div>
												</div>

												<div className="col-xs-8 miles-opened">
													<div className="to-receive">
														<p className="identifier">A receber:</p>
														<p className="value">
															<strong>{formatCurrency(summaryPayment.feeToReceive)}</strong>
														</p>
													</div>
													<div className="plus-separator">
														<p>+</p>
													</div>
													<div className="received">
														<p className="identifier">Recebido:</p>
														<p className="value">
															<strong>{formatCurrency(summaryPayment.feeRecived)}</strong>
														</p>
													</div>
													<div className="equals-separator">
														<p>=</p>
													</div>
													<div className="total">
														<p className="identifier">Total:</p>
														<p className="value">
															<strong>
																{formatCurrency(
																	summaryPayment.feeToReceive + summaryPayment.feeRecived
																)}
															</strong>
														</p>
													</div>
												</div>
												<div className="col-xs-16 next-month-mobile">
													<div className="col-xs-8 border-top">
														<p className="month-name">
															<strong>{nextMonth.toUpperCase()}</strong>
														</p>
														<div className="row no-margin">
															<div className="next-to-receive">
																<p className="identifier">A receber:</p>
																<p>
																	<strong className="value">
																		{formatCurrency(summaryPayment.toReceiveNextMonth)}
																	</strong>
																</p>
															</div>
														</div>
													</div>
													<div className="col-xs-8 border-top my-sales-link">
														<NavLink to={`${ROUTE_SALE}`} data-action="summary-payment-sales">
															Minhas vendas
														</NavLink>
													</div>
												</div>
												<div
													className={`summary-payment__details-button ${
														showDetails ? "opened" : ""
													}`}
												>
													<button
														className="btn btn-icon"
														onClick={() => this.setState({ showDetails: !showDetails })}
														data-action="summary-payment-expand-collapse"
													>
														<i className="icon-arrow-down" />
													</button>
												</div>
											</div>
										</React.Fragment>
									)}
							</div>
						</div>
					)}
				</div>
			);
		} else {
			return (
				<div className="row summary-payment">
					<h1 className="my-offers--header">Minhas Ofertas</h1>
					{loading && <Loading label="Carregando valores" />}
					{!loading && (
						<React.Fragment>
							<div className="col-xs-12 summary-payment--current-month">
								<p className="month-name">
									<strong>{currentMonth.toUpperCase()}</strong>
								</p>
								<div className="row summary-payment--current-month--grid">
									<div className="miles">
										<p className="identifier">Milhas</p>
									</div>
									<div className="to-receive">
										<p className="identifier">A receber:</p>
										<p className="value">
											<strong>{formatCurrency(summaryPayment.toReceive)}</strong>
										</p>
									</div>
									<div className="plus-separator">
										<p>+</p>
									</div>
									<div className="received">
										<p className="identifier">Recebido:</p>
										<p className="value">
											<strong>{formatCurrency(summaryPayment.received)}</strong>
										</p>
									</div>
									<div className="equals-separator">
										<p>=</p>
									</div>
									<div className="total">
										<p className="identifier">Total:</p>
										<p className="value">
											<strong>{formatCurrency(summaryPayment.totalMonth)}</strong>
										</p>
									</div>

									{showDetails &&
										!loading && (
											<React.Fragment>
												<span />
												<div className="miles">
													<p className="identifier">Taxas</p>
												</div>
												<div className="to-receive">
													<p className="identifier">A receber:</p>
													<p className="value">
														<strong>{formatCurrency(summaryPayment.feeToReceive)}</strong>
													</p>
												</div>
												<div className="plus-separator">
													<p>+</p>
												</div>
												<div className="received">
													<p className="identifier">Recebido:</p>
													<p className="value">
														<strong>{formatCurrency(summaryPayment.feeRecived)}</strong>
													</p>
												</div>
												<div className="equals-separator">
													<p>=</p>
												</div>
												<div className="total">
													<p className="identifier">Total:</p>
													<p className="value">
														<strong>
															{formatCurrency(
																summaryPayment.feeToReceive + summaryPayment.feeRecived
															)}
														</strong>
													</p>
												</div>
											</React.Fragment>
										)}
								</div>
							</div>
							<div className="col-xs-4 summary-payment--next-month">
								<p className="month-name">
									<strong>{nextMonth.toUpperCase()}</strong>
								</p>
								<div className="row no-margin">
									<div className="next-to-receive">
										<p className="identifier">A receber:</p>
										<p>
											<strong className="value">
												{formatCurrency(summaryPayment.toReceiveNextMonth)}
											</strong>
										</p>
									</div>
								</div>

								{showDetails &&
									!loading && (
										<React.Fragment>
											<div className="my-sales-link">
												<NavLink to={`${ROUTE_SALE}`} data-action="summary-payment-sales">
													Minhas vendas
												</NavLink>
											</div>
										</React.Fragment>
									)}
							</div>

							<div className={`summary-payment__details-button ${showDetails ? "opened" : ""}`}>
								<button
									className="btn btn-icon"
									onClick={() => this.setState({ showDetails: !showDetails })}
									data-action="summary-payment-expand-collapse"
								>
									<i className="icon-arrow-down" />
								</button>
							</div>
						</React.Fragment>
					)}
				</div>
			);
		}
	}
}

const mapStateToProps = state => ({
	summaryPayment: state.summaryPayment.data
});

const mapDispatchToProps = dispatch => {
	return {
		receiveSummaryPayment: data => dispatch(receiveSummaryPayment(data))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPayment);
